import { TextOverrides } from '../redux/stateInterface';

function getSeatTriggerSubtitle(
  hasSeats: boolean,
  textOverrides: TextOverrides
) {
  if (!hasSeats) return textOverrides.seat_load_failed ?? 'seat_load_failed';
  if (textOverrides && textOverrides.card_seat_trigger_subtitle_available)
    return textOverrides.card_seat_trigger_subtitle_available;

  return 'seat_load_success';
}

function getBaggageTriggerTitle(
  textOverrides: TextOverrides
): string | undefined {
  if (textOverrides && textOverrides.card_baggage_trigger_title)
    return textOverrides.card_baggage_trigger_title;
}

export { getSeatTriggerSubtitle, getBaggageTriggerTitle };
